import { render, staticRenderFns } from "./PointsHero.vue?vue&type=template&id=8bb12010&scoped=true&"
import script from "./PointsHero.vue?vue&type=script&lang=js&"
export * from "./PointsHero.vue?vue&type=script&lang=js&"
import style0 from "./PointsHero.vue?vue&type=style&index=0&id=8bb12010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb12010",
  null
  
)

export default component.exports